import { Loader2, CheckCircle2, AlertCircle } from "lucide-react";

/**
 * Inline per-file upload progress rows. Pass an array of items shaped:
 *   { id, name, pct, status: "queued"|"uploading"|"done"|"error", error? }
 */
export default function UploadProgressList({ items, dataTestId = "upload-progress" }) {
  if (!items || items.length === 0) return null;
  return (
    <ul data-testid={dataTestId} className="mt-3 space-y-1.5">
      {items.map((it) => {
        const isDone = it.status === "done";
        const isErr = it.status === "error";
        const pct = Math.max(0, Math.min(100, it.pct ?? 0));
        return (
          <li
            key={it.id}
            data-testid={`upload-row-${it.id}`}
            className="text-xs bg-[var(--pa-bg-2)] border border-[var(--pa-border)] rounded px-3 py-2"
          >
            <div className="flex items-center gap-2">
              {isDone ? (
                <CheckCircle2 size={12} className="text-emerald-400 shrink-0" />
              ) : isErr ? (
                <AlertCircle size={12} className="text-red-400 shrink-0" />
              ) : (
                <Loader2
                  size={12}
                  className="animate-spin text-[var(--pa-gold)] shrink-0"
                />
              )}
              <span className="flex-1 truncate text-[var(--pa-text)]">{it.name}</span>
              <span
                data-testid={`upload-pct-${it.id}`}
                className={`text-[10px] uppercase tracking-wider ${
                  isErr ? "text-red-300" : "text-[var(--pa-text-muted)]"
                }`}
              >
                {isDone ? "done" : isErr ? "failed" : `${pct}%`}
              </span>
            </div>
            {!isDone && !isErr && (
              <div className="mt-1.5 h-1 rounded-full bg-[var(--pa-surface-hover)] overflow-hidden">
                <div
                  className="h-full bg-[var(--pa-gold)] transition-[width] duration-150"
                  style={{ width: `${pct}%` }}
                  data-testid={`upload-bar-${it.id}`}
                />
              </div>
            )}
            {isErr && it.error && (
              <div className="mt-1 text-[10px] text-red-300 leading-tight">{it.error}</div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
